var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: "添加货物",
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "800px"
          },
          on: { close: _vm.close }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "add-goods-form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "goods-item",
                  attrs: { label: "货物：", prop: "goodsCategoryid" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择货物" },
                      on: { focus: _vm.selectFocus, change: _vm.selectChange },
                      model: {
                        value: _vm.ruleForm.goodsCategoryid,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "goodsCategoryid", $$v)
                        },
                        expression: "ruleForm.goodsCategoryid"
                      }
                    },
                    _vm._l(_vm.goodsArr, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "goods-weight-item",
                  attrs: { label: "重量：", prop: "goodsWeight" }
                },
                [
                  _c("el-input", {
                    attrs: { type: "number", placeholder: "请选择重量" },
                    model: {
                      value: _vm.ruleForm.goodsWeight,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "goodsWeight", $$v)
                      },
                      expression: "ruleForm.goodsWeight"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "件数：", prop: "goodsNumber" } },
                [
                  _c("el-input", {
                    attrs: { type: "number", placeholder: "请选择件数" },
                    model: {
                      value: _vm.ruleForm.goodsNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "goodsNumber", $$v)
                      },
                      expression: "ruleForm.goodsNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5805dee4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5805dee4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/deliver/components/handlingWrapper/components/addGoodsDialog/index.vue
// module id = null
// module chunks = 